/**
 *
 * @returns {number|jQuery}
 */
export default function checkIfAnimating() {
  return $(':animated').length;
}



// WEBPACK FOOTER //
// local_static/templates/motor/2017/assets/scripts/checkIfAnimating.js